import { create } from "zustand";

export const useModal = create((set, get) => ({
    content: {
        html: null,
        width: "1200",
        state: false,
        position: "center"
    },
    open: (content) => set({ content }),
    close: () => {
        set({
            content: {
                ...get().content,
                state: false
            }
        });
    }
}));
